import React from 'react';
import './App.css';
import {Button, Container, Image} from "react-bootstrap";
import ReactPlayer from "react-player/lazy";

const App = () => {
    const handleMap = () => {
        window.open("https://www.google.com/maps/place/Main+Entrance+National+Memorial+Cemetery/@33.6966199,-112.0276447,17z/data=!4m13!1m7!3m6!1s0x872b70126ec37953:0x669f932ae4261014!2s23029+N+Cave+Creek+Rd,+Phoenix,+AZ+85024!3b1!8m2!3d33.6963298!4d-112.0276876!3m4!1s0x872b706d891832b3:0xcb5160435add5815!8m2!3d33.6985511!4d-112.0198345");
    };

    // @ts-ignore
    return (
        <Container className="mt-3">
            <h4 className="mb-3" style={{textDecoration: "underline"}}>Nat'l Memorial Cemetery of AZ</h4>
            <h6>23029 N. Cave Creek Road, Phoenix, AZ 85024</h6>
            <Button variant="link" onClick={handleMap}>View Google Map</Button>
            <Image src="map.png" fluid={true}/>
            <p>When you come into the cemetery, off of Pinnacle Peak Road, turn in and there will be a long drive. You
                will pass an electric sign board on the right side of the drive, then you will get to the end of the
                drive where you have to turn left or right – turn left. Proceed a short distance, until you see the sign
                for Columbarium Court A - park near that sign:</p>
            <Image src="columbarium-a.png" fluid={true}/>
            <p>Then a short distance past that, you will see <b>Columbarium Courts G - J</b>, follow that sign to get
                to <b>Columbarium J</b>, and go to <b>location 67</b>:</p>
            <Image src="marker-darker.png" fluid={true}/>
            <p>Above is a picture of their marker in the wall. It is on the bottom row of the wall at ground level.
                Their ashes are stored behind that marker.</p>
            <p>During the memorial service on January 19, 2022, the following award and letter were presented to us in
                honor of Dad’s service in the U.S. Navy:</p>
            <Image src="award1.png" fluid={true}/>
            <Image src="award2.png" fluid={true}/>
            <p>This picture was taken during the memorial service. 2 service members folded the flag in front of us –
                there is a picture of Mom and Dad too:</p>
            <Image src="service-members.png" fluid={true}/>
            <p>During the service, there was a 4 gun salute with military honors:</p>
            <Image src="gun-salute.png" fluid={true}/>
            <p>They played taps:</p>
            <Image src="taps.png" fluid={true}/>
            <div className="player-wrapper">
                <ReactPlayer className="react-player" url="videos/taps.mp4" width="100%" height="100%" controls={true}/>
            </div>
            <p>After the military honors, the Chaplain gave a Christian ulogy for my Dad regarding his military service and said a prayer.  The service members also presented us with the folded flag and the chaplain presented us with 3 shells from the firing of the guns (which were still warm when he handed them to me).  He said that the shells stood for:</p>
            <ol>
                <li>Duty</li>
                <li>Honor</li>
                <li>Country</li>
            </ol>
            <p>The following is a letter we were given by the cemetery expressing their condolences and giving general information about the cemetery:</p>
            <Image src="letter.png" fluid={true}/>
            <p>Here are Dad’s Navy discharge papers:</p>
            <Image src="discharge.png" fluid={true}/>
            <p>Dad treasured this picture of him and Mom - it was from our wedding day (July 16, 1988):</p>
            <Image src="bogie.png" fluid={true}/>
        </Container>
    );
};

export default App;
